module.exports = {
	"id": "VN",
	"name": "Viet Nam",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006646,
			"11": 0.013292,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006646,
			"17": 0.013292,
			"18": null,
			"19": 0.03323,
			"20": 0.03323,
			"21": 0.013292,
			"22": 0.019938,
			"23": 0.013292,
			"24": null,
			"25": null,
			"26": 0.013292,
			"27": null,
			"28": 0.013292,
			"29": 0.059814,
			"30": 0.006646,
			"31": 0.06646,
			"32": 0.013292,
			"33": 0.013292,
			"34": 0.019938,
			"35": 0.006646,
			"36": 0.013292,
			"37": 0.006646,
			"38": 0.026584,
			"39": 0.073106,
			"40": 0.013292,
			"41": 0.059814,
			"42": 0.039876,
			"43": 0.458574,
			"44": 0.086398,
			"45": 0.073106,
			"46": 0.385468,
			"47": 0.16615,
			"48": 0.206026,
			"49": 2.339392,
			"50": 0.691184,
			"51": 3.9876,
			"52": 0.525034,
			"53": 19.525948,
			"54": 5.197172,
			"55": 0.079752,
			"56": 0.019938,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.039876,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.006646,
			"10": null,
			"11": null,
			"12": 0.013292,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.093044,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006646,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.006646,
			"31": 0.013292,
			"32": null,
			"33": 0.039876,
			"34": 0.006646,
			"35": 0.013292,
			"36": 0.03323,
			"37": 0.006646,
			"38": 0.172796,
			"39": 0.079752,
			"40": 0.019938,
			"41": 0.03323,
			"42": 0.03323,
			"43": 0.372176,
			"44": 0.086398,
			"45": 0.259194,
			"46": 0.385468,
			"47": 1.681438,
			"48": 0.49845,
			"49": 3.02393,
			"50": 0.079752,
			"51": 0.006646,
			"52": null,
			"3.5": 0.006646,
			"3.6": 0.026584
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.006646,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.013292,
			"35": null,
			"36": 0.013292,
			"37": 0.046522,
			"38": 0.684538,
			"39": 0.013292,
			"40": 0.23261,
			"41": 0.03323,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03323
		},
		"safari": {
			"0": null,
			"4": 0.026584,
			"5": 0.006646,
			"6": null,
			"7": 0.046522,
			"8": 0.09969,
			"9": 0.112982,
			"10": 0.538326,
			"3.1": null,
			"3.2": null,
			"5.1": 0.013292,
			"6.1": 0.013292,
			"7.1": null,
			"9.1": 0.39876
		},
		"ios_saf": {
			"8": 0,
			"10": 6.81415507744,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.183633594505,
			"8.1-8.4": 0.339255284763,
			"9.0-9.2": 0.161846557868,
			"9.3": 2.46919748543
		},
		"android": {
			"3": 0,
			"4": 0.0517486666667,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00646858333333,
			"4.1": 0.186664833333,
			"4.2-4.3": 0.466662083333,
			"4.4": 1.0700885,
			"4.4.3-4.4.4": 1.07932933333
		},
		"ie": {
			"6": 0.0147902312139,
			"7": 0.0221853468208,
			"8": 1.08708199422,
			"9": 0.26622416185,
			"10": 0.273619277457,
			"11": 0.894808988439,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0765605357098,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0021266815475
		},
		"edge": {
			"12": 0.053168,
			"13": 0.292424,
			"14": 0.285778
		},
		"ie_mob": {
			"10": 0.273138422535,
			"11": 1.11206357746
		},
		"bb": {
			"7": 0.038571,
			"10": null
		},
		"samsung": {
			"0": 0.959244
		},
		"and_uc": {
			"0": 2.072772
		},
		"op_mini": {
			"0": 1.03148678274
		},
		"and_chr": {
			"0": 16.36786
		},
		"and_ff": {
			"0": 0.040248
		}
	},
	"total": 81.710589
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VN.json
 ** module id = 680
 ** module chunks = 0
 **/